import React from 'react'
import PropTypes from 'prop-types'
import image13 from './image13.jpeg'

const CV_Ilia = () => {
    return (
        <div className="card" style={{flexBasis: 255, flexGrow: 0, marginBottom: 30}}>
            <img className="card-img-top" src={image13} alt="Card image cap"/>
            <div className="card-body">
                <h5 className="card-title">Илия Димитров</h5>
                <p className="card-text">Пловдивски университет „Паисий Хилендарски“, Филологически факултет, студент по българска филология</p>
            </div>
            <div className="card-footer">
                <span  data-toggle="modal" data-target="#CVIlia" className="btn btn-danger" style={{width: '100%'}}>Научете повече</span>
            </div>
            <div className="modal fade" id="CVIlia" tabindex="-1" role="dialog" aria-labelledby="CVIliaLabel" aria-hidden="true">
                <div className="modal-dialog" style={{maxWidth: 640}}role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="CVIliaLabel">Илия Димитров</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>ИЛИЯ РОСЕНОВ ДИМИТРОВ е студент в Пловдивския университет „Паисий Хилендарски“ в специалност „Българска филология“. Редактор е на пловдивското културно списание „НУЛА32“. Репортер и автор в младежкия уебпортал MediaCafe.BG, където поддържа рубрики за съвременна литература, театър, музикална и клубна сцена. Интересите му са в сферата на художествената публицистика, славянските литератури, екранното и фотографско изкуство.
                        </p>

                        <h3>Избрани публикации:</h3>
                        <ul> 
                            <li>„Безвремието на балканския човек – Иво Андрич и Йордан Радичков“. Пловдив, 2018 (309 стр.), В: „Словото – идеи, идеали, утопии“ ISBN 978-619-202-342-3</li>
                        </ul>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Затвори</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default CV_Ilia



// WEBPACK FOOTER //
// ./src/modules/OurTeam/CV_Ilia.jsx